import { t } from "i18next";

export interface GenderOption {
  id: string;
  name: string;
}

export const optionsGender: GenderOption[] = [
  { id: "Hombre", name: "Masculino" },
  { id: "Mujer", name: "Femenino" },
];

export const getOptionsStatusBusiness = () => [
  { id: "interested", name: t("recovery.views.interested") },
  { id: "initial_contact", name: t("recovery.views.initial_contact") },
  { id: "presentation", name: t("recovery.views.presentation") },
  { id: "negotiation", name: t("recovery.views.negotiation") },
  { id: "won", name: t("recovery.views.won") },
  { id: "lost", name: t("recovery.views.lost") },
  { id: "quarantine", name: t("recovery.views.quarantine") },
];

export const revenueOption = () => [
  { id: "store", name: t("kpi.views.Tienda") },
  { id: "fee", name: t("kpi.views.Cuota") },
  { id: "bond", name: t("kpi.views.Bono_servicios") },
  { id: "bond_slot", name: t("kpi.views.Bono_espacios") },
];

export const IMAGE_URL_BASE = "https://dash.fitmewise.com/uploads";
